import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '@/auth/useAccessToken';
import { ignoredSendersApi, type IgnoredSender } from './ignoredSendersApi';

/** The inbound ignore-list, for the admin management screen. */
export function useIgnoredSenders() {
  const getAccessToken = useAccessToken();
  return useQuery<IgnoredSender[]>({
    queryKey: ['ignored-senders'],
    queryFn: ({ signal }) => ignoredSendersApi.list(getAccessToken, signal)
  });
}
